module.exports = __webpack_public_path__ + "static/media/s29kz.e9c1cb69.pdf";